export default "__VITE_ASSET__25f04452__"